"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFrom = exports.parseWildcard = void 0;
// --------------------------
// parsers
// --------------------------
function parseWildcard(template, path) {
    var templateSplit = template.split("/");
    var pathSplit = path.split("/");
    var params = {};
    for (var i = 0; i < templateSplit.length && i < pathSplit.length; i++) {
        var curr = templateSplit[i];
        if (curr === "*") {
            params["tail"] = pathSplit.slice(i, pathSplit.length).join("/");
        }
        if (curr[0] === "{") {
            var key = curr.slice(1, curr.length - 1);
            params[key] = pathSplit[i];
        }
    }
    return params;
}
exports.parseWildcard = parseWildcard;
function parseFrom(from) {
    var url = new URL(from);
    // for some reason new URL(protocol://path).pathname === //path
    // => remove first "/" from pathname
    var path = url.pathname.slice(1);
    // for some reason new URL(protocol://path).protocol === protocol:
    // => remove ":" from protocol
    var protocol = url.protocol.slice(0, url.protocol.length - 1);
    if (protocol !== "updates") {
        var parsed = parseWildcard("/communities/{communityId}/channels/{channelId}/*", path);
        return {
            protocol: protocol,
            params: parsed
        };
    }
    else {
        var parsed = parseWildcard("/*", path);
        return {
            protocol: protocol,
            params: parsed
        };
    }
}
exports.parseFrom = parseFrom;
